import { data } from '@/components/Form/FormTree/data';
<template>
  <div>
    <img :src="imgSrc" alt="" />
  </div>
</template>

<script>
import { loadingConfig } from '@/utils/commonConfig'
export default {
  data() {
    return {
      imgSrc: '',
    }
  },
  created() {
    this.getProccessImg()
  },
  methods: {
    getProccessImg() {
      const loading = this.$loading(loadingConfig)
      _api.approval.getProcessImg({
        approvalId: this.$route.params.approvalId
      }).then(data => {
        this.imgSrc = 'data:image/png;base64,' + data
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>

<style>

</style>